import React, {Component} from 'react';
import Validator from '../../modules/Validator';
import * as Rules from '../../misc/rules';
import * as HttpConfigs from '../../configs/http';
import {http, endpoints} from '../../configs/http';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionCreators} from '../../data/ActionCreators';
import SimpleReactValidator from "simple-react-validator";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Login extends Component {
    state = {
        touched: [],
        form: {
            username: '',
            password: '',
        },
        validation: null,
        isLoading: false,
    };
    componentDidMount() {

        this.validator = new SimpleReactValidator();
    }
    setupValidator() {


    }


    handleValidatorOnChange(validation) {
        this.setState({validation});
    }

    rules() {
        return {
            username: {
                required: Rules.required,
            },
            password: {
                required: Rules.required,
            },
        };
    }
    messages() {
        return {
            username: {
                required: 'Please enter your MKAN ID.',
            },
            password: {
                required: 'Please enter your password.',
            },
        };
    }

    valid() {
        var {validation} = this.state;
        if (!validation || !validation.valid) {
            return false;
        }
        return true;
    }

    fieldError(field) {
        if (!this.fieldHasError(field)) {
            return;
        }
        var field = this.state.validation.fields[field] || null;
        if (!field) {
            return;
        }
        return field.error;
    }
    handleOnBlur(field) {

        console.log(field)
        var {touched} = this.state;
        if (touched.indexOf(field) == -1) {
            touched.push(field);
            this.setState({touched});
        }
    }

    fieldHasError(field) {
        var {touched, validation} = this.state;
        if (!validation || !validation.fields || !validation.fields[field]) {
            return false;
        }
        if (touched.indexOf(field) !== -1 && !validation.fields[field].valid) {
            return true;
        }
        return false;
    }
    handleChange(event) {
        const { name, value } = event.target;
        this.setState({
            [name]: value
        });
    }
    formatText = (text) => {
        return text.replace(/[^+\d]/g, '');
    };
    handleOnTextChange(field, input) {
        const { name, value } = input.target;
        var form = Object.assign({}, this.state.form);
        form[field] = value.trim();
        this.setState({form});
        console.log(form)
        console.log(this.state.validation)
    }

    submit = (event) => {
        event.preventDefault();
        if (!this.validator.allValid()) {
            this.validator.showMessages();
            // rerender to show messages for the first time
            // you can use the autoForceUpdate option to do this automatically`
            this.forceUpdate();
            return;
        }

        this.setState({
            isLoading: true,
        });
        var form = Object.assign({}, this.state.form);

        // make http request
        http
            .post(endpoints.LOGIN, form, {
                headers: HttpConfigs.headers,
            })
            .then(async (resp) => {
                console.log(resp);
                // await asyncStore(STORE_KEYS.LOGIN_DATA, form);
                this.getUserDetails(resp.token);
                // this.setState({
                //     showMessage: false,
                // });
            })
            .catch((err) => {
                console.log(err);
                this.setState({
                    isLoading: false,
                });
                let errorMessage =
                    (typeof err === 'string' && err) ||
                    'An error occured, please try again in a moment.';
                // alert(JSON.stringify(error));
                console.log(errorMessage);
                toast.error(errorMessage)
                // this.setState({
                //     snacksMessage: errorMessage,
                //     showMessage: true,
                // });
            });

        // setTimeout(() => {
        //   this.setState({
        //     isLoading: false,
        //   });
        //   this.props.navigation.navigate('home');
        // }, 2000);
    };

    getUserDetails = (token) => {
        // this.setState({
        //   loading:true
        // });

        axios({
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
            method: 'get',
            url: HttpConfigs.url + endpoints.USER_DETAILS,
        })
            .then(async (user) => {
                this.setState({
                    isLoading: false,
                });

                console.log(user.data);
                // var result =jwtDecode(user.data.token);
                // console.log(result)

                var data = {};
                data.user = user.data;
                data.token = token;
                this.props.login(data);
                window.location = "/dashboard";
                //
                // await asyncStore(STORE_KEYS.AUTH_USER, data);
                // try {
                //     const serializedState = JSON.stringify(data)
                //     localStorage.setItem('authData', serializedState)
                // } catch (e) {
                //     console.log(e)
                // }

                // data.access_token = token;
                // data.user = user.data;
                // data.refresh_token = token;
                // data.names = "Admin";
                // data.role = "Member";
                // data.memberId = result.sub;
                // // dispatch(setUserData(res));
                //
                // this.props.setUserData(data);
                // history.push({
                //   pathname: "/"
                // });
            })
            .catch((error) => {
                this.setState({
                    isLoading: false,
                });

                if (error && error.response) {
                    if (error.response.data && error.response.data.error) {
                        this.setState({
                            snacksMessage: error.response.data.error,
                            showMessage: true,
                        });
                        return false;
                    }

                    if (error.response.data && error.response.data.message) {
                        this.setState({
                            snacksMessage: error.response.data.message,
                            showMessage: true,
                        });
                        return false;
                    }

                    this.setState({
                        snacksMessage: 'An unknown error occured.',
                        showMessage: true,
                    });

                    return false;
                }
            });
    };


    render() {
        const {form, isLoading} = this.state
        return (

            <div className="auth-form-wrapper px-4 py-5">

                {/*<a href="#" className="noble-ui-logo logo-light d-block mb-2 text-center">Send<span>champ</span></a>*/}
                <div className={'text-center mb-2'}>
                    <img src="assets/img/logo.png" className="logo" alt={'MAKN MAAL'}/>
                </div>
                <h5 className="text-muted font-weight-normal mb-4 text-center ">Welcome back! Log in to your
                    maal account.</h5>
                <form className="forms-sample col-lg-9 offset-lg-2" onSubmit={this.submit.bind(this)}>


                    <div className="form-group">
                        <label htmlFor="email" className="">MKAN ID</label>

                        <div className="">
                            <input id="username" type="username" className="form-control "
                                   name="username"  required  autoFocus

                                   onChange={this.handleOnTextChange.bind(this, 'username')}

                                   onBlur={this.handleOnBlur.bind(this, 'username')}
                                   value={form.username}

                            />

                            {/*        @error('email')*/}
                            {this.validator &&
                            <span className="invalid-feedback" role="alert">
                                <strong>
                                    {this.validator.message(
                                        "username",
                                        form.username,
                                        "required"
                                    )}
                                  </strong>
                            </span>
                            }

                            {/*        @enderror*/}
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="password" className="">Password</label>

                        <div className="">
                            <input id="password" type="password"
                                   className="form-control" name="password"
                                   required autoComplete="current-password"



                                   onChange={this.handleOnTextChange.bind(this, 'password')}

                                   onBlur={this.handleOnBlur.bind(this, 'password')}
                                   value={form.password}
                            />

                            {this.validator &&
                            <span className="invalid-feedback" role="alert">
                                <strong> {this.validator.message(
                                    "password",
                                    form.password,
                                    "required"
                                )}</strong>
                            </span>
                            }


                            {/*        @error('password')*/}
                            {/*        <span className="invalid-feedback" role="alert">*/}
                            {/*    <strong>{{$message}}</strong>*/}
                            {/*</span>*/}
                            {/*        @enderror*/}
                        </div>
                    </div>


                    <div className="text-center mt-4">
                        <div class="">
                            <button type="submit" className="btn btn-primary btn-lg btn-block "      disabled={isLoading} style={{padding: 10}}>
                                {isLoading ?
                                    <span className='spinner-grow'></span>
                                    :

                                    "Login"
                                }



                            </button>

                        </div>
                    </div>
                    <div className="text-center mt-3">
                        <div className="">

                            {/*<br>*/}
                            {/*<a class="btn btn-link" href="{{ route('register') }}">*/}
                            {/*{{__("Don't have an account? Create")}}*/}
                            {/*</a>*/}
                        </div>
                    </div>
                </form>
                <ToastContainer />
            </div>
        );
    }
}


const mapStateToProps = (state) => {
    const {auth} = state;
    return {auth};
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            login: ActionCreators.login,
            setUpAuthorized: ActionCreators.setUpAuthorized
        },
        dispatch,
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);

